import styled from "styled-components";
import { theme } from "../../../../../theme";

export const PopularOptionsLabel = styled('p')`
  font-size: 14px;
  margin-top: ${theme.offsets.sm};
  margin-bottom: -${theme.offsets.xs};
`